// extracted by css-extract-rspack-plugin
export default {"ColumnItemRoot":"jYCTh","dragging":"TtP4j","Draggable":"fOiwd","ColumnItemDragHandle":"l7afs"};